<template>
    <div class="chart" :id="id"></div>
</template>

<script>
    export default {
        name: "chart",
        props:['option','id','domWidth'],
        data(){
            return{
                chart:''
            }
        },
        mounted() {
            this.initEchart()
        },
        methods:{
            initEchart(){
                const vm=this;
                vm.chart=vm.$echarts.init(document.getElementById(this.id));
                vm.chart.setOption(this.option);
                window.addEventListener('resize',function () {
                    vm.chart.resize();
                })
                // 点击事件
                vm.chart.on("click", function (param) {
                    // console.log(param);
                    vm.$emit('event', param)
                })
            }
        },
        watch:{
            option:{
                handler(val){
                    if(this.chart){
                        this.chart.setOption(val,true)
                    }
                },
                deep:true
            },
            domWidth(val,oldVal){
                this.chart.resize()
            }
        }
    }
</script>

<style scoped lang="less">
.chart{width:100%;height:100%;}
</style>